export const GET_SHIPPING_USER_ID = 'GET_SHIPPING_USER_ID';

export const EDIT_SHIPPING_USER = {
    REQUEST: 'SHIPPING_USER.EDIT.REQUEST',
    SUCCESS: 'SHIPPING_USER.EDIT.SUCCESS',
    FAILED: 'SHIPPING_USER.EDIT.FAILED'
};
